import React, { useEffect, useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router';

import { ThemeProvider } from 'components/theme/ThemeProvider';

import { initLocalization } from 'helpers/localization/LocalizationFunctions';

import { Layout } from './components/Layout';
import { LoginFlowProvider } from './contexts/LoginFlowContext';
import LoginRoutes from './routes';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
        },
        mutations: {
            retry: false,
        },
    },
});

const UpdatedAppWrapper = () => {
    const [intl, setIntl] = useState<{ locale: string; messages: Record<string, string> } | null>(
        null,
    );

    useEffect(() => {
        initLocalization('web').then(({ locale, messages }) => {
            setIntl({ locale, messages: messages as Record<string, string> });
        });
    }, []);

    if (!intl) {
        return null;
    }

    return (
        <IntlProvider locale={intl.locale} messages={intl.messages}>
            <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                    <LoginFlowProvider>
                        <ThemeProvider>
                            <Layout>
                                <LoginRoutes />
                            </Layout>
                        </ThemeProvider>
                    </LoginFlowProvider>
                </QueryClientProvider>
            </BrowserRouter>
        </IntlProvider>
    );
};

export default UpdatedAppWrapper;
